/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetUniverseSchematicsSchematicIdOk
 */
export interface GetUniverseSchematicsSchematicIdOk {
    /**
     * Time in seconds to process a run
     * @type {number}
     * @memberof GetUniverseSchematicsSchematicIdOk
     */
    cycleTime: number;
    /**
     * schematic_name string
     * @type {string}
     * @memberof GetUniverseSchematicsSchematicIdOk
     */
    schematicName: string;
}

/**
 * Check if a given object implements the GetUniverseSchematicsSchematicIdOk interface.
 */
export function instanceOfGetUniverseSchematicsSchematicIdOk(value: object): value is GetUniverseSchematicsSchematicIdOk {
    if (!('cycleTime' in value) || value['cycleTime'] === undefined) return false;
    if (!('schematicName' in value) || value['schematicName'] === undefined) return false;
    return true;
}

export function GetUniverseSchematicsSchematicIdOkFromJSON(json: any): GetUniverseSchematicsSchematicIdOk {
    return GetUniverseSchematicsSchematicIdOkFromJSONTyped(json, false);
}

export function GetUniverseSchematicsSchematicIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseSchematicsSchematicIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'cycleTime': json['cycle_time'],
        'schematicName': json['schematic_name'],
    };
}

export function GetUniverseSchematicsSchematicIdOkToJSON(json: any): GetUniverseSchematicsSchematicIdOk {
    return GetUniverseSchematicsSchematicIdOkToJSONTyped(json, false);
}

export function GetUniverseSchematicsSchematicIdOkToJSONTyped(value?: GetUniverseSchematicsSchematicIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cycle_time': value['cycleTime'],
        'schematic_name': value['schematicName'],
    };
}

